import { Card, Stack, FormGroup, FormLabel } from "react-bootstrap"
import { ErrorsProps, ICalculatorState } from "../Types/calculator"
import { sections } from "../Utilities/constants"

export function Errors(props: ErrorsProps) {
  const { state, setSettings } = props
  const { expandedSections } = state

  // this is a little gross but it was a tradeoff to get the sweet SectionProps<SectionField> interface
  const invalid = sections.map((section) => {
    const invalidFields = !expandedSections.includes(section.name) ? [] : 
      Object.keys(section.fields)
        .filter(field => 
          !section.fields[field as keyof typeof section.fields]!.validationFunction(state[field as keyof ICalculatorState], state)
        );
    return { section, invalidFields };
  });

  return (
    <Card>
      <Card.Header as="h3" style={{ backgroundColor: "var(--bs-danger)" }}>
        ERROR: Input(s) Out of Range
      </Card.Header>
      <Card.Body>
        <h6 style={{ marginBottom: "2rem" }}>Click on an incorrect input to open that section.</h6>
        <Stack gap={2}>
          {invalid.map(
            ({ section, invalidFields }) =>
              invalidFields.length > 0 && (
                <span key={section.name}>
                  <h3>{section.name}</h3>
                  {invalidFields.map((field: string) => {
                    const invalidField = section.fields[field as keyof typeof section.fields]!
                    return (
                    <FormGroup
                      key={field}
                      onClick={() => {
                        const newExpandedSections: string[] = expandedSections.includes(section.name)
                          ? expandedSections.filter((s) => s !== section.name)
                          : [...expandedSections, section.name]
                        setSettings({ expandedSections: newExpandedSections, activeCategory: section.name })
                        document.getElementById(section.name)?.scrollIntoView()
                      }}
                    >
                      <FormLabel
                        style={{ cursor: "pointer" }}
                        title="Click to navigate to the section with the out-of-range input"
                      >
                        {invalidField.outOfRangeMessage}
                      </FormLabel>
                    </FormGroup>
                  )})}
                </span>
              )
          )}
        </Stack>
      </Card.Body>
    </Card>
  )
}